import { render, staticRenderFns } from "./TextHeader.vue?vue&type=template&id=9a611c9c&scoped=true&"
import script from "./TextHeader.vue?vue&type=script&lang=ts&"
export * from "./TextHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TextHeader.vue?vue&type=style&index=0&id=9a611c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a611c9c",
  null
  
)

export default component.exports